import type { AuthStatus } from '../types/auth.js';

let cachedAuthStatus: AuthStatus | null = null;

export function getCachedAuthStatus(): AuthStatus | null {
  return cachedAuthStatus;
}

export function setCachedAuthStatus(status: AuthStatus): void {
  cachedAuthStatus = status;
}

export function clearAuthStatusCache(): void {
  cachedAuthStatus = null;
}
